import { AppPromptSeverity } from "~graphql/generated/types"
import type { AppPromptFieldsFragment } from "~graphql/app-prompts.generated"

const SEVERITY_PRIORITY: Record<AppPromptSeverity, number> = {
    [AppPromptSeverity.Blocking]: 0,
    [AppPromptSeverity.Warning]: 1,
    [AppPromptSeverity.Info]: 2,
}

export function getHighestPriorityPrompt(
    prompts: readonly AppPromptFieldsFragment[]
): AppPromptFieldsFragment | null {
    if (prompts.length === 0) return null

    return (
        [...prompts].sort((left, right) => {
            const severityDiff =
                SEVERITY_PRIORITY[left.severity] -
                SEVERITY_PRIORITY[right.severity]
            if (severityDiff !== 0) return severityDiff
            return left.id.localeCompare(right.id)
        })[0] ?? null
    )
}

export function isBlockingPrompt(prompt: AppPromptFieldsFragment): boolean {
    return prompt.severity === AppPromptSeverity.Blocking
}
